const th = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title': 'ชื่อแหล่งการค้นพบ',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'Id ผู้ใช้',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Url Service Now',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'รหัสผ่าน',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Url ไม่ถูกต้อง',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'ความถี่การค้นพบ',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'แจ้งผู้ใช้ให้คำตอบคำถามสำหรับการตรวจสอบสิทธิ์ที่อ้างอิงจากความรู้ (KBA)',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'พบกับแอปและภาระงานของคุณผ่านหนึ่งในแหล่งการค้นพบที่เป็นที่นิยมเหล่านี้ คุณจะได้ปลดล็อกสิทธิประโยชน์ต่างๆ อย่างเช่นรายละเอียดที่กรอกไว้ล่วงหน้า คำแนะนำที่จัดลำดับความสำคัญไว้ และมุมมองสถานะที่ออนบอร์ดแล้วแบบเต็ม',
  'INTEGRATIONS.DISCOVERY.BACK': 'ย้อนกลับ',
  'INTEGRATIONS.DISCOVERY.TITLE': 'ตั้งค่าการค้นพบ',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'เร็วๆ นี้..',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'เรียนรู้เพิ่มเติม',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'ป้อนข้อมูลประจำตัวแอปพลิเคชันของคุณเพื่อสร้างการเชื่อมต่อ เมื่อเชื่อมต่อสำเร็จ คุณจะสามารถนำเข้าข้อมูลได้',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING': 'มีบางสิ่งผิดพลาดระหว่างการโหลดหน้า',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'ลองรีเฟรชหรือกลับมาตรวจสอบในภายหลัง หากปัญหายังคงเกิดขึ้น โปรดติดต่อผู้ดูแลระบบ',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'โหลดอีกครั้ง',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'การตั้งค่าการเชื่อมต่อ',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'คลาส CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'การแมปแอตทริบิวต์',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'รายละเอียดการเชื่อมต่อ',
  'INTEGRATIONS.BUTTON.SAVE': 'บันทึก',
  'INTEGRATIONS.DISCOVERY.SELECT': 'เลือก',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'สร้างการเชื่อมต่อใหม่',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'ใช้การเชื่อมต่อนี้',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'บันทึก ServiceNow แล้ว!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'การเชื่อมต่อของคุณกับ ServiceNow แหล่งการค้นพบถูกทดสอบและบันทึกสำเร็จแล้ว นำเข้าข้อมูลเพื่อทำการตั้งค่าการค้นพบให้เสร็จสิ้น คุณอาจข้าม ...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'นำเข้าสินทรัพย์',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'ข้ามไปก่อน',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'เมื่อการนำเข้าเริ่มขึ้น จะไม่สามารถยกเลิกได้',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'แนะนำฉัน',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'เลือกการเชื่อมต่อที่มีอยู่',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'ชื่อการเชื่อมต่อ',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'เราค้นพบการกำหนดค่าการเชื่อมต่อที่มีอยู่{total, plural, one {} other {#}}:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'เริ่มนำเข้า',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'กำลังนำเข้าข้อมูลจากไฟล์ Excel โปรดรอ...',
  'INTEGRATIONS.TRY.AGAIN': 'ลองอีกครั้ง',
  'INTEGRATIONS.CLOSE': 'ปิด',
  'INTEGRATIONS.ERROR.CONNECTION': 'ข้อผิดพลาดการเชื่อมต่อ โปรดลองอีกครั้ง',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'คุณสามารถออกจากหน้านี้ได้ระหว่างที่รอ เราจะแจ้งให้คุณทราบเมื่อกระบวนการเสร็จสมบูรณ์',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'นำเข้าแหล่งการค้นพบ',
  'INTEGRATIONS.FILEUPLOAD.HEADING': 'นำเข้าแหล่งการค้นพบของคุณจากไฟล์',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'ดาวน์โหลดไฟล์ตัวอย่าง',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'ชื่อแหล่งการค้นพบ',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'ป้อนชื่อไฟล์',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'โปรดป้อนชื่อที่ถูกต้อง อนุญาตเฉพาะตัวอักษร ตัวเลข และสัญลักษณ์ที่กำหนดเท่านั้น',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'กำลังอัปโหลด...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'ต่อไป',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'รายการนี้คือบันทึก 10 รายการแรกจากไฟล์ XLSX ที่อัปโหลด',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'ส่วนหัวที่จำเป็นหายไป',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'ตรวจพบข้อผิดพลาดคอลัมน์',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'โปรดแก้ไขปัญหาก่อนดำเนินการนำเข้าข้อมูล',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'แยกออกจากการนำเข้า',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'การยืนยันการออนบอร์ดสำหรับการใช้งานแอปพลิเคชัน',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'เราได้ระบุประเภทแอปพลิเคชันไว้ โปรดยืนยันว่านี่คือประเภทแอปพลิเคชันที่ถูกต้องที่คุณกำลังออนบอร์ดอยู่',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'ประเภทแอปพลิเคชันที่คุณกำลังออนบอร์ดคือ {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'ไม่ใช่ เลือกจากรายการแอปพลิเคชัน',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'ใช่ ฉันกำลังออนบอร์ด',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'การบูรณาการ',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'เพิ่มการผสานการทำงาน',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'ไม่พบผลลัพธ์สำหรับ',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'ไม่ใช่',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'พบการผสานการทำงาน',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'ไม่มีการผสานการทำงานที่ซ่อนอยู่',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'ค้นพบแอปพลิเคชันแล้ว',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'เจ้าของ:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'ค้นพบล่าสุดเมื่อ',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'การเชื่อมต่อล้มเหลว',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'ผู้ใช้มีสิทธิ์การเข้าถึง',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'แหล่งการค้นพบ',
  'INTEGRATIONS.BUTTON.ENABLE': 'เปิดใช้งาน',
  'INTEGRATIONS.BUTTON.DISABLE': 'ปิดใช้งาน',
  'INTEGRATIONS.ENABLING': 'กำลังเปิดใช้งาน',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'การค้นพบ',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'อัปโหลดใหม่',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'ออนบอร์ด',
  'INTEGRATIONS.DASHBOARD.HIDE': 'ซ่อน',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'ยกเลิกการซ่อน',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'แท็บการกำหนดค่าการค้นพบ',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'ละทิ้งการเปลี่ยนแปลงที่ไม่ได้บันทึกใช่ไหม',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'คุณมีการเปลี่ยนแปลงที่ไม่ได้บันทึก การเปลี่ยนแปลงจะสูญหายหากคุณดำเนินการต่อ',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'ละทิ้งการเปลี่ยนแปลง',
  'INTEGRATIONS.BUTTON.CANCEL': 'ยกเลิก',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'บันทึกข้อผิดพลาด',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': 'กลับไปยังหน้าก่อนหน้า',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'ไอคอนแอปพลิเคชัน',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'เรียกใช้ด้วยตนเอง',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': 'การปิดใช้งานล้มเหลว',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'การเปิดใช้งานล้มเหลว',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'ปิดใช้งานสำเร็จแล้ว',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'เปิดใช้งานสำเร็จแล้ว',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'ขณะนี้การนำเข้าอื่นอยู่ในระหว่างดำเนินการ',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'ขณะนี้สินทรัพย์อยู่ในระหว่างการนำเข้าด้วยกระบวนการอื่น โปรดลองอีกครั้งในภายหลัง',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': 'การนำเข้าล้มเหลว',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'กำลังนำเข้าสินทรัพย์จาก ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'คุณสามารถออกจากหน้านี้ได้ระหว่างที่รอ เราจะแจ้งให้คุณทราบเมื่อกระบวนการเสร็จสมบูรณ์',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'เพิ่มแถวการแมปแอตทริบิวต์ใหม่',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'เพิ่มแอตทริบิวต์',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(ว่าง)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'ลบการแมปนี้',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ฟิลด์ ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'ฟิลด์ Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'ค้นหาแอตทริบิวต์ ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'ค้นหาแอตทริบิวต์ Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(กำหนดเอง)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'การบันทึกล้มเหลว',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'การกำหนดค่าการกำหนดเวลา',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'เวลา {timeLabel} UTC',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'ทำซ้ำในวันที่',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'ทำซ้ำทุก วัน',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'ทำซ้ำทุกๆ',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'ป้อนช่วงเวลา',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'ช่วงเวลาที่ซ้ำเป็นจำนวนวัน สัปดาห์ หรือเดือน',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'วัน',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'สัปดาห์',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'เดือน',
  'INTEGRATIONS.DAYS.SUN': 'อา.',
  'INTEGRATIONS.DAYS.MON': 'จ.',
  'INTEGRATIONS.DAYS.TUE': 'อ.',
  'INTEGRATIONS.DAYS.WED': 'พ.',
  'INTEGRATIONS.DAYS.THU': 'พฤ.',
  'INTEGRATIONS.DAYS.FRI': 'ศ.',
  'INTEGRATIONS.DAYS.SAT': 'ส.',
  'INTEGRATIONS.BUTTON.DISABLING': 'กำลังปิดใช้งาน',
  'INTEGRATIONS.BUTTON.SAVED': 'บันทึกแล้ว',
  'INTEGRATIONS.BUTTON.SAVING': 'กำลังบันทึก',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE':
    'คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งาน ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'เมื่อปิดใช้งานแหล่งการค้นพบ การนำเข้าสินทรัพย์จะหยุดลงและคุณจะไม่สามารถกำหนดค่าแหล่งที่มาได้',
  'INTEGRATIONS.DISCOVERY.HERE': 'ที่นี่',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'แหล่งการค้นพบถูกสร้างสำเร็จแล้ว แต่การเชื่อมต่อกับ ServiceNow ล้มเหลว หากต้องการเริ่มการนำเข้าสินทรัพย์ โปรดอัปเดตรายละเอียดการเชื่อมต่อในหน้าการกำหนดค่าแหล่งการค้นพบ ',
};

export default th;
